export const selectFilteredUserProducts = state => {
  return {
    ...state.userProducts,
    data: state.userProducts.data.filter(
      product => product.slug !== 'helixa-affinity'
    ),
  };
};
